import React from 'react';
import PropTypes from 'prop-types';
// Utils
import { RichTextPropTypes } from '../../prop-types';
import { consistentString } from '../../utils/content-formatting';
import { replaceLineBreakShortCode } from '../../utils/replace-shortcode-br';
// Components
import RichText from '../rich-text';
import { propLink } from '../link-handler';
import { Container } from '../styled/containers';
import CTA from '../cta';
// Styles
import {
  CTAWrapper,
  FlexContainer,
  LeftColumn,
  ImageHolder,
  RightColumn,
  BodyTextWrapper,
  Title,
  Wrapper,
} from './styles';

const BrandHero = ({ content }) => {
  const {
    title,
    bodyText,
    image,
    brandHeroCTA: cta,
    backgroundColor,
    primaryBrandHero,
    overlayPaddingBottom,
    removeMarginBottom,
  } = content;

  return (
    <Wrapper
      $backgroundColor={consistentString(backgroundColor)}
      $overlayPaddingBottom={overlayPaddingBottom}
      $removeMarginBottom={removeMarginBottom}
    >
      <Container>
        <FlexContainer>
          <LeftColumn>
            <ImageHolder $image={image} />
          </LeftColumn>
          <RightColumn $primaryBrandHero={primaryBrandHero}>
            <Title
              as={primaryBrandHero ? 'h1' : 'h3'}
              $primaryBrandHero={primaryBrandHero}
            >
              {replaceLineBreakShortCode(title)}
            </Title>
            <BodyTextWrapper>
              <RichText richText={bodyText} />
            </BodyTextWrapper>
            {cta ? (
              <CTAWrapper>
                <CTA
                  bg={primaryBrandHero ? 'primary' : 'secondary-standard'}
                  link={cta.link}
                >
                  {cta.buttonText}
                </CTA>
              </CTAWrapper>
            ) : null}
          </RightColumn>
        </FlexContainer>
      </Container>
    </Wrapper>
  );
};

BrandHero.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    bodyText: RichTextPropTypes.isRequired,
    image: PropTypes.object,
    brandHeroCTA: PropTypes.shape({
      buttonText: PropTypes.string.isRequired,
      link: propLink.isRequired,
    }),
    backgroundColor: PropTypes.oneOf(['White', 'Grey']),
    overlayPaddingBottom: PropTypes.bool,
    primaryBrandHero: PropTypes.bool,
    removeMarginBottom: PropTypes.bool,
  }),
};

BrandHero.defaultProps = {
  content: {
    backgroundColor: 'White',
    overlayPaddingBottom: false,
    primaryBrandHero: false,
    removeMarginBottom: false,
  },
};

export default BrandHero;

export const BrandHeroAssembly = ({ contentfulData }) => (
  <BrandHero
    content={{
      title: contentfulData.title,
      bodyText: contentfulData.bodyText,
      image: contentfulData.image,
      brandHeroCTA: contentfulData.brandHeroCTA,
      backgroundColor: contentfulData.backgroundColor,
      primaryBrandHero: contentfulData.primaryBrandHero,
      overlayPaddingBottom: contentfulData.overlayPaddingBottom,
      removeMarginBottom: contentfulData.removeMarginBottom,
    }}
  />
);

BrandHeroAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
